module.exports = __webpack_public_path__ + "img/flower-top-big.517af825.png";